module.exports = __webpack_public_path__ + "static/hallenstadion-e757835bd36125c47e45c4198b3ad173.png";